import { Component, Input, OnInit } from '@angular/core';
import { JiraIssue } from '../core/models/jira-issue.model';
import { WindowRefService } from '../core/services/windowRef.service';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { NgIf } from '@angular/common';
import { ObsidianNoteDTO } from '../core/models/obsidian-note.model';
import { ApiService } from '../core/services/api.service';
import { NotesComponent, SelectedNoteEvent } from './notes.component';
import { marked } from 'marked';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpParams } from '@angular/common/http';
import { LozengeComponent, LozengeType } from '../shared/lozenge/lozenge.component';

@Component({
  selector: 'app-issue-details',
  templateUrl: './issue-details.component.html',
  standalone: true,
  imports: [SpinnerComponent, NgIf, NotesComponent, LozengeComponent],
})
export class IssueDetailsComponent implements OnInit {
  @Input() jiraIssue?: JiraIssue;

  selectedNote?: ObsidianNoteDTO;
  notes: ObsidianNoteDTO[] = [];
  loading = true;
  renderer: any;

  constructor(
    private apiService: ApiService,
    private windowRefService: WindowRefService,
    private sanitizer: DomSanitizer,
  ) {
    const renderer = {
      link({ href, title, text }: any) {
        const titleAttr = title ? ` title="${title}"` : '';
        return `<a href="${href}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
      },
    };

    // Use the renderer in marked
    marked.use({ renderer });
  }

  get LozengeType() {
    return LozengeType;
  }

  async ngOnInit(): Promise<void> {
    await this.loadNotes();
    this.loading = false;
    this.windowRefService.AP.resize('', 250);
  }

  async onSelectedNote(event: SelectedNoteEvent): Promise<void> {
    try {
      const selectedNote = await this.apiService.get<ObsidianNoteDTO>(`/notes/${event.selectedNote.id}`);
      if (selectedNote && !selectedNote.content) {
        selectedNote.content = 'No content';
      } else {
        const formattedContent = marked(selectedNote?.content || '').toString();
        if (selectedNote) {
          selectedNote.formattedContent = this.sanitizer.bypassSecurityTrustHtml(formattedContent) as string;
        }
      }

      this.selectedNote = selectedNote;
    } catch (error) {
      console.error('Cannot get content of selected note due to:', error);
    }
  }

  private async loadNotes(): Promise<void> {
    try {
      /**
       * 
       * // Group notes by vaultName
      const grouped = notes.reduce((acc, note) => {
        if (!acc[note.vaultName]) {
          acc[note.vaultName] = [];
        }
        acc[note.vaultName].push(note);
        return acc;
      }, {});
       */
      let params = new HttpParams();
      params = params.set('issueKey', this.jiraIssue?.getKey() ?? 'no-issue-key');
      this.notes = (await this.apiService.get<ObsidianNoteDTO[]>('/notes', params)) ?? [];
    } catch (error) {
      console.error('Cannot get notes due to:', error);
    }
  }
}
